import { SkeletonItem } from "@fluentui/react-components";
import React from "react";

export function SkeletonLoader() {
  return (
    <>
      {[1, 2, 3].map((item) => (
        <SkeletonItem id="skeleton" style={{ height: 25, marginBottom: 10 }} animation={"pulse"} key={item} />
      ))}
    </>
  );
}
